export const passwordRules = [
  { test: (v) => v.length >= 8, msg: '至少 8 個字元' },
  { test: (v) => /[A-Z]/.test(v), msg: '至少一個大寫字母' },
  { test: (v) => /[a-z]/.test(v), msg: '至少一個小寫字母' },
  { test: (v) => /\d/.test(v), msg: '至少一個數字' },
  { test: (v) => /[~!@#$%^&*(){}\[\]:;"'<>,.?\/\\|_+=-]/.test(v), msg: '至少一個特殊字符' }
]

export function checkPassword(value) {
  return passwordRules.map(rule => ({
    ...rule,
    passed: rule.test(value || '')
  }))
}

export function isPasswordValid(value) {
  return checkPassword(value).every(r => r.passed)
}